module.exports = __webpack_public_path__ + "static/WpK_lazienka_pakiet_srebrny-42375e3ac27157d29d3a07051afc891f.jpg";